export default {
  env: 'DEV', // todo change?
  isDev: !!process.env.VUE_APP_DEV,
  isStaging: String(process.env.VUE_APP_IS_STAGING).toLowerCase() === 'true',
  proxyHost: process.env.VUE_APP_PROXY_HOST as string || 'http://localhost:8080',
  ratePlanMediaUrl: process.env.VUE_RATE_PLAN_MEDIA_URL as string || 'https://busyrooms.cdnserver.net/bnccdn/rateplans/',
  storageKey: process.env.VUE_APP_STORAGE_KEY as string || 'reka',
  validateZipApiUrl: process.env.VUE_APP_REKA_MBB_URL as string || 'https://busyrooms.azure-api.net/reka-mb-vpd/',
  expiryTime: 30, // 30 minutes
  validateAddressUrl: 'https://busyrooms.azure-api.net/reka-mb-int2/',
  dateFormat: 'YYYY-MM-DD',
  dateShownFormat: 'DD.MM.YYYY',
  maxAdultAge: 100,

  get apiUrl() {
    // return localStorage.getItem('coreApiBaseUrl')
    const apiPath = localStorage.getItem('langedPath')
    return apiPath ? `${apiPath}/server/coreapi/` : ''
  },

  get searchAndBookApi() {
    const apiPath = localStorage.getItem('langedPath')
    return apiPath ? `${apiPath}/server/searchandbook/` : ''
  },

  get bookingApi() {
    const apiPath = localStorage.getItem('langedPath')
    return apiPath ? `${apiPath}/server` : ''
  }
}
